import type * as Types from 'app/types/graphql';

import {
  ShopPlatformPlanActiveSelectFragmentDoc,
  ShopPlatformPlanSelectFragmentDoc,
} from '../fragments/shopPlatformPlan.generated';
import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { PlanSelectFragmentDoc } from '../fragments/plan.generated';
import { appFetcher } from '~/api/utils/gatewayClient';
export type ShopPlatformPlanActiveQueryVariables = Types.Exact<{
  shopPlatformId: Types.Scalars['ID']['input'];
}>;

export type ShopPlatformPlanActiveQueryResponse = {
  shopPlatformPlanActive?: Types.Maybe<
    Pick<
      Types.ShopPlatformPlan,
      'id' | 'planID' | 'confirmationURL' | 'startDate' | 'endDate' | 'status'
    > & {
      plan?: Types.Maybe<
        Pick<
          Types.Plan,
          | 'id'
          | 'name'
          | 'displayName'
          | 'priority'
          | 'isTrial'
          | 'basePrice'
          | 'billingCycle'
          | 'deprecated'
          | 'conditions'
          | 'createdAt'
          | 'updatedAt'
          | 'trialDays'
        >
      >;
    }
  >;
};

export const ShopPlatformPlanActiveDocument = `
    query ShopPlatformPlanActive($shopPlatformId: ID!) {
  shopPlatformPlanActive(shopPlatformID: $shopPlatformId) {
    ...ShopPlatformPlanActiveSelect
  }
}
    ${ShopPlatformPlanActiveSelectFragmentDoc}
${ShopPlatformPlanSelectFragmentDoc}
${PlanSelectFragmentDoc}`;

export const useShopPlatformPlanActiveQuery = <
  TData = ShopPlatformPlanActiveQueryResponse,
  TError = unknown,
>(
  variables: ShopPlatformPlanActiveQueryVariables,
  options?: UseQueryOptions<ShopPlatformPlanActiveQueryResponse, TError, TData>,
) => {
  return useQuery<ShopPlatformPlanActiveQueryResponse, TError, TData>(
    ['ShopPlatformPlanActive', variables],
    appFetcher<ShopPlatformPlanActiveQueryResponse, ShopPlatformPlanActiveQueryVariables>(
      ShopPlatformPlanActiveDocument,
      variables,
    ),
    options,
  );
};

useShopPlatformPlanActiveQuery.getKey = (variables: ShopPlatformPlanActiveQueryVariables) => [
  'ShopPlatformPlanActive',
  variables,
];
